export const INITIALIZE_QUESTION_MODULE = 'INITIALIZE_QUESTION_MODULE'
export const INITIALIZE_CUSTOM_QUESTION_MODULE =
  'INITIALIZE_CUSTOM_QUESTION_MODULE'
